module.exports = __webpack_public_path__ + "media/images/games/35gender/cook-afe2ddb11c456b410d00b0c65f37f5f2.png";